// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SavableRegion[data-v-61107d2c]
	{
		position: relative;
}
.SavableOverlay[data-v-61107d2c]
	{
		position: absolute;
		z-index: 10;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		background-color: rgba(0,0,0,0.5);
		display: flex;
		justify-content: center;
		align-items: flex-start;
}
.SavingProgress[data-v-61107d2c]
	{
		position: sticky;
		top: 50px;
		background-color: #FFFFFF;
		padding: 10px 20px;
		border: 1px solid #EEEEEE;
		border-radius: 5px;
		box-shadow: rgba(0,0,0,0.4) 2px 2px 4px 2px;
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/SavableRegion.vue"],"names":[],"mappings":";AA8BC;;EAEC,kBAAkB;AACnB;AAEA;;EAEC,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACxB;AAEA;;EAEC,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC5C","sourcesContent":["<template>\r\n\t<div class=\"SavableRegion\">\r\n\t\t<div class=\"SavableContent\"><slot></slot></div>\r\n\t\t<div class=\"SavableOverlay\" v-if=\"saving\">\r\n\t\t\t<div class=\"SavingProgress\">\r\n\t\t\t\t<ScaleLoader />\r\n\t\t\t\t<br />\r\n\t\t\t\t{{text}}\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tsaving: {\r\n\t\t\t\ttype: Boolean,\r\n\t\t\t\trequired: true\r\n\t\t\t},\r\n\t\t\ttext: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"Saving\"\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.SavableRegion\r\n\t{\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.SavableOverlay\r\n\t{\r\n\t\tposition: absolute;\r\n\t\tz-index: 10;\r\n\t\ttop: 0px;\r\n\t\tleft: 0px;\r\n\t\tright: 0px;\r\n\t\tbottom: 0px;\r\n\t\tbackground-color: rgba(0,0,0,0.5);\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: flex-start;\r\n\t}\r\n\r\n\t.SavingProgress\r\n\t{\r\n\t\tposition: sticky;\r\n\t\ttop: 50px;\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 10px 20px;\r\n\t\tborder: 1px solid #EEEEEE;\r\n\t\tborder-radius: 5px;\r\n\t\tbox-shadow: rgba(0,0,0,0.4) 2px 2px 4px 2px;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
